// Price history limit/stop prices are null when they don't apply to the
// order type (no stop on a LIMIT, no limit on a STOP).
export function formatHistoryPrice(price) {
  if (price == null) return '-'
  return parseFloat(price).toFixed(2)
}
